import { FormProvider, useForm } from 'react-hook-form';

import { Feedback, FeedbackType } from '@/modules/perseo-billing/components';
import {
  schema,
  yupResolver
} from '@/modules/perseo-billing/containers/payment-methods/components/cards/cards.schema';
import {
  DEFAULT_FEEDBACKS,
  DEFAULT_FORM_VALUES,
  LABEL_ENTER_YOUR_CARD_DETAILS
} from '@/modules/perseo-billing/containers/payment-methods/components/spreedly-cards/constants';
import FormBody from '@/modules/perseo-billing/containers/payment-methods/components/spreedly-cards/form/spreedly-form-body.component';
import FormFooter from '@/modules/perseo-billing/containers/payment-methods/components/spreedly-cards/form/spreedly-form-footer.component';
import { useSpreedly } from '@/modules/perseo-billing/containers/payment-methods/components/spreedly-cards/hooks/use-spreedly';
import { PaymentProcessor } from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';
import { LocalHookFormDevtool } from '@/sections/shared/hooks/local-hookform-devtool';

interface CustomSpreedlyFormProps {
  methodId: PaymentProcessor;
}

export const CustomSpreedlyForm = (props: CustomSpreedlyFormProps) => {
  const creditCardForm = useForm({
    resolver: yupResolver(schema),
    defaultValues: DEFAULT_FORM_VALUES
  });

  return (
    <FormProvider {...creditCardForm}>
      <PaymentForm {...props} />
      <LocalHookFormDevtool control={creditCardForm.control} />
    </FormProvider>
  );
};

const PaymentForm = ({ methodId }: CustomSpreedlyFormProps) => {
  const isCencosud = methodId === PaymentProcessor.TRANSBANK_CENCOSUD_CARD;

  const spreedly = useSpreedly({
    methodId: methodId,
    isCencosud
  });

  const { isCvvValid } = spreedly;

  return (
    <form
      id="payment-form"
      className="co-flex co-flex-col co-gap-16px co-py-16px co-px-24px"
    >
      {DEFAULT_FEEDBACKS?.map((item, index) => (
        <Feedback
          type={FeedbackType['INFO']}
          subtitle={item?.subtitle}
          key={index}
        />
      ))}

      <p className="co-text-[16px] co-leading-[24px] co-text-[#454545]">
        {LABEL_ENTER_YOUR_CARD_DETAILS}
      </p>

      <div className="co-flex co-flex-row co-gap-24px">
        <div
          className={`co-flex co-flex-col co-w-full ${isCvvValid ? 'co-gap-4' : ''}`}
        >
          <FormBody {...spreedly} isCencosud={isCencosud} />
          <FormFooter {...spreedly} isCencosud={isCencosud} />
        </div>
      </div>
    </form>
  );
};
